import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  checkCRPFeatureEnabled,
  checkIdtfServiceProviderFeatureEnabled,
  checkTKFeatureEnabled,
} from '../../../configs';
import { getLatestConnectionStatus } from '../../../legacy/pages/PatientFile/util';

const BreadcrumbNav = ({ history, me, connectionInfo }) => {
  const {
    location: { pathname },
  } = history;
  const pathParts = pathname.split('/');
  const parentPage = pathParts[1];
  const backLink = pathParts.slice(0, 2).join('/');
  const selectedSettingsTab = useSelector(
    state => state.settings && state.settings.selectedPageTab,
  );
  const selectedPatientTab = useSelector(
    state => state.patientFile && state.patientFile.selectedTab,
  );
  const dataMap = {
    patients: selectedPatientTab,
    settings: selectedSettingsTab,
  };
  const styles = {
    text: {
      textTransform: 'capitalize',
    },
    margin: {
      marginTop: '10px',
    },
  };
  const isIdtfServiceEnabled = checkIdtfServiceProviderFeatureEnabled(me);
  const isTKFeatureEnabled = checkTKFeatureEnabled(me);
  const isCRPFeatureEnabled = checkCRPFeatureEnabled(me);

  const getOverviewTablLabel = () => {
    const connectionStatus =
      connectionInfo &&
      connectionInfo.status &&
      getLatestConnectionStatus(connectionInfo).status;
    if (isIdtfServiceEnabled)
      return <FormattedMessage id="tabs.label.profile" />;
    return connectionStatus === 'pending' ||
      connectionStatus === 'connected' ? (
      <FormattedMessage id="tabs.label.overview" />
    ) : (
      <FormattedMessage id="tabs.label.order" />
    );
  };

  const getMyinfoTablLabel = () => {
    if (isTKFeatureEnabled || isCRPFeatureEnabled)
      return <FormattedMessage id="tabs.label.myinfo" />;
    return <FormattedMessage id="tabs.label.Update_Password" />;
  };

  const tabLabelMap = {
    EKGS: <FormattedMessage id="tabs.label.ECG" />,
    OVERVIEW: getOverviewTablLabel(),
    PROFILE: <FormattedMessage id="tabs.label.profile" />,
    REPORTS: <FormattedMessage id="app.SideNav.Reports" />,
    BLOOD_PRESSURES: <FormattedMessage id="tabs.label.Blood_Pressure" />,
    WEIGHTS: <FormattedMessage id="table.column.header.Weight" />,
    TEAM_MEMBERS: <FormattedMessage id="tabs.label.team_members" />,
    INVITE_TEAM_MEMBER: <FormattedMessage id="tabs.label.invite_members" />,
    INBOX_SETTINGS: <FormattedMessage id="tabs.label.Inbox_Settings" />,
    UPDATE_PASSWORD: getMyinfoTablLabel(),
    KARDIA_RX: <FormattedMessage id="tabs.label.KardiaRx_ECG" />,
  };
  const pageNameMap = {
    settings: <FormattedMessage id="app.SideNav.Settings" />,
  };
  const handleNavigation = e => {
    e.preventDefault();
    history.push(backLink);
  };
  return (
    <Breadcrumbs aria-label="breadcrumb" style={styles.margin}>
      <Link
        color="inherit"
        href={backLink}
        underline="always"
        onClick={handleNavigation}
      >
        <Typography variant="body2" style={styles.text}>
          {pageNameMap[parentPage] || parentPage}
        </Typography>
      </Link>
      <Typography variant="body2" style={styles.text}>
        {tabLabelMap[dataMap[parentPage && parentPage.toLowerCase()]]}
      </Typography>
    </Breadcrumbs>
  );
};

export default withRouter(BreadcrumbNav);



// WEBPACK FOOTER //
// ./src/views/components/BreadcrumbNavigation/BreadcrumbNav.jsx